import * as z from "zod";
import type { AdvisingSession } from "../types";

export const sessionTitleSchema = z
  .string()
  .min(1, "Title must be at least 1 character.")
  .max(255, "Title must be 255 characters or fewer.");

export interface AdvisingSessionsProps {
  loading?: boolean;
  error?: boolean;
  previousFetching?: boolean;
  mostRecentSession?: AdvisingSession;
  sessions?: AdvisingSession[];
  offset?: number;
  limit?: number;
  total?: number;
  canEditTitle?: boolean;
}

export type AdvisingSessionsEmits = {
  (e: "view-detail", session: AdvisingSession): void;
  (e: "page-change", offset: number): void;
  (e: "update-title", sessionId: string, title: string): void;
};
